import { createJurisdictionHeaders } from '@/data';
import { URLS } from '@/data/config';
import { LOG_TAG_ACCOUNT_DETAILS_UPDATE } from '@/feature/verify-phone-number/utils/constants';
import { logger } from '@/utils/logging';
import { useMutation } from '@tanstack/react-query';

/**
 * Custom react query mutation hook to update username
 * POST /auth/user/username-change
 */
export const useUpdateUsername = () => {
    return useMutation({
        mutationFn: async (username: string) => {
            const response = await fetch(`${URLS.CHAMELON_API_URL}/auth/user/username-change`, {
                method: 'POST',
                headers: {
                    ...createJurisdictionHeaders(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username,
                }),
            });

            let responseData;

            try {
                responseData = await response.json();
            } catch (error) {
                logger.warn(
                    LOG_TAG_ACCOUNT_DETAILS_UPDATE,
                    'Failed to parse response JSON for useUpdateUsername',
                    error
                );
                responseData = null;
            }

            if (!response.ok) {
                logger.warn(LOG_TAG_ACCOUNT_DETAILS_UPDATE, 'Error updating username', responseData);
                throw responseData;
            }

            return responseData;
        },
    });
};
